import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import VendorLedger from './VendorLedger';
const { rootUrl } = require('../../../config/config');

const VendorLedgerPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { token } = useAuth();
    const authToken = token || localStorage.getItem('authToken');

    const [supplierName, setSupplierName] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${rootUrl}/parts/suppliers/${id}`, {
            headers: { Authorization: `Bearer ${authToken}` }
        })
            .then(res => res.json())
            .then(data => setSupplierName(data?.name || ''))
            .catch(err => console.error('Error fetching supplier:', err))
            .finally(() => setLoading(false));
    }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    if (loading) {
        return <div className="p-6 text-sm text-gray-500">Loading...</div>;
    }

    return (
        <div className="p-4 md:p-6 min-h-screen bg-[#fff8f5]">
            {/* Page header */}
            <div className="flex items-center gap-3 mb-6">
                <button
                    onClick={() => navigate('/vendors')}
                    className="h-8 w-8 flex items-center justify-center rounded-sm border border-gray-300 hover:bg-gray-50 text-gray-600"
                >
                    <FontAwesomeIcon icon={faArrowLeft} className="text-sm" />
                </button>
                <div>
                    <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#FF5733]">Vendors</p>
                    <h1 className="text-xl font-bold text-gray-900">{supplierName} — Ledger</h1>
                </div>
            </div>

            <VendorLedger supplierId={parseInt(id)} supplierName={supplierName} />
        </div>
    );
};

export default VendorLedgerPage;
